<template>
  <layout-editor-page
    :title="formTitle"
    :isLoading="isLoadingStore || isLoading"
    :isVisible="isVisible"
    :isBack="hasCreateNew"
    :isCancel="!hasCreateNew"
    @command="setCommand"
  >
    <div class="row">
      <div class="col-xl-8 col-12 order-2 order-xl-1">
        <component
          v-for="step in steps"
          v-show="currentStep >= step.index"
          :disabledEmployee="!isVisibleAddToQuote"
          :disabled="disabled"
          :moduleName="moduleName"
          :key="step.index"
          :is="step.component"
          :title="step.title"
          :isValid.sync="step.isValid"
          :showButton="step.showButton"
          :eventID="eventID"
          :data="dataRFQ"
          :model="modelRFQ"
          @onAutoSave="mixAutoSave"
          @command="controller($event, step)"
        />
        <po-form
          v-if="currentStep >= 4"
          :title="this.L10n('create-po')"
          :data="dataPo"
          :fieldPO="fieldPO"
          :isValid.sync="step4.isValid"
          :model="modelRFQ"
          @onAutoSave="mixAutoSave"
          @onUpdatePO="handleUpdatePO"
          @onCreatePO="handleCreatePO"
        />
      </div>
      <div class="col-xl-4 col-12 order-1 order-xl-2 vb-xl">
        <!-- RFQ INFO -->
        <info-data-rfq v-if="currentStep > 1" :data="dataRFQ" />
        <el-button
          type="primary"
          plain
          @click="openCustomerRemainder"
          :style="{ width: '100%' }"
        >
          {{L10n('show-customer-reminder')}}
        </el-button>
        <!-- PARTS INFO -->
        <info-section-parts
          v-if="currentStep > 1"
          :listRFQ1="listRFQ1"
          :mapListRFQ3="mapListRFQ3"
          @onAddToRFQ3="openDialogAddToRFQ3"
          @onSend="sendQuoteToCustomerEmailPart"
          @onSendFollowup="sendQuoteFollowUp"
        />
        <!-- QUOTES INFO -->
        <info-data-rfq3
          v-if="currentStep > 2"
          :data="listRFQ3"
          :rfqID="dataRFQ.id"
          @onMultiple="handleCheckMultipleQuote"
          @onSendMultiple="sendQuoteMultiParts"
          >
          <template v-slot:controls={row}>
            <button
              class="btn btn-size-xs"
              @click="sendQuoteToCustomerEmail(row, false)"
            >{{L10n('send-quote-to-customer-email')}}</button>
            <hr style="width: 100%">
          </template>
        </info-data-rfq3>
        <info-data-rfq :title="L10n('po')" v-if="currentStep > 3" :data="dataRFQ" :model="modelInfoPo">
          <template v-slot:header>
            <span class="title">{{L10n('po')}}: </span> <span>{{fieldPO}}</span>
          </template>
        </info-data-rfq>
      </div>
    </div>
    <!-- DIALOG -->
    <dialog-add-to-rfq3 :isLoading="isLoading" ref="dialog-add-to-rfq3" />
    <dialog-send-quote-to-customer-email
      ref="dialogSendQuote"
      :rfqID="dataRFQ.id"
      :rfq3ID="dataRFQ3Send.id"
      @onSuccess="handlerSuccessCustomerEmail"
    />
    <dialog-send-quote-to-customer-email-part
      ref="dialogSendQuotePart"
      :rfqID="dataRFQ.id"
    />
    <dialog-send-quote-multi-parts
      ref="dialogSendQuoteMultiParts"
      :rfqID="dataRFQ.id"
      :partIDs="partIDs"
      @onSuccess="handlerSuccessCustomerEmail"
    />
    <dialog-reminder-table :title="L10n('reminder-table')" ref="dialogCustomerRemainder" :companyID="dataRFQ.customerCompanyID" />
  </layout-editor-page>
</template>

<script>
import { ServiceRFQs, ModelRFQs, ModelInfoPOShort } from '@/services/RFQs'
import FormWrapper from '@/components/Form/FormWrapper'
import { AutoSaveMixin } from '@/mixins/FormAutoSave'

export default {
  name: 'ModalNewLabel',
  mixins: [FormWrapper, AutoSaveMixin],
  components: {
    'add-to-rfq-3': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQAddToRFQ3/Index.vue'),
    'list-customer-quotes': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ListCustomerQuotes/Index.vue'),
    'main-rfq-form': () => import(/* webpackChunkName: 'RFQPending' */ './FormMainRFQ'),
    'po-form': () => import(/* webpackChunkName: 'RFQPending' */ './FormPo'),
    'info-data-rfq3': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoDataRFQ3'),
    'info-section-po': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoSectionPO'),
    'info-data-rfq': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoDataRFQ'),
    'info-section-parts': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoSectionParts'),
    'dialog-add-to-rfq3': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQDialogAddToRFQ3/Index'),
    'dialog-send-quote-multi-parts': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/DialogSendQuoteMultiParts'),
    'dialog-send-quote-to-customer-email': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SendQuoteToCustomerEmail/Index'),
    'dialog-send-quote-to-customer-email-part': () => import(/* webpackChunkName: 'QuickRFQ' */ '@/components/Shared/DialogSendEmailToCustomerByPart'),
    'dialog-reminder-table': () => import(/* webpackChunkName: 'DialogRemainderTable' */ '@/components/Shared/DialogRemainderTable')
  },
  props: {
    disabled: { type: Boolean, required: true },
    config: { type: Object },
    moduleName: { type: String }
  },
  data () {
    return {
      currentStep: 2,
      dataRFQ3Send: {},
      steps: [
        { index: 1, title: this.L10n('rfq'), component: 'main-rfq-form', isValid: false },
        { index: 2, title: this.L10n('add-parts'), component: 'add-to-rfq-3', isValid: false, showButton: true },
        { index: 3, title: this.L10n('customer-quote'), component: 'list-customer-quotes', isValid: false, showButton: true }
      ],
      step4: {
        isValid: false
      },
      eventID: 'rfq-pending'
    }
  },
  computed: {
    isAvailableToSave () {
      return true
    },
    isVisibleAddToQuote () {
      const permissions = this.$store.getters.get('permissions')
      return this.permission(permissions, 'isAllowToViewQuickRFQByParts')
    },
    showSendCustomerButton () {
      return this.listRFQ3.some(({ chosen }) => chosen)
    },
    formTitle () {
      return this.dataRFQ.rfqid || this.checkEs6AndRun(this.title)
    },
    mapListRFQ3 () {
      return this.$store.getters[`${this.moduleName}/mapListRFQ3`]
    },
    isLoadingStore () {
      return this.$store.state[this.moduleName].isLoading
    },
    dataRFQ () {
      return { ...this.$store.state[this.moduleName].dataRFQ, poDate: new Date() }
    },
    dataPo () {
      return {
        ...this.dataRFQ,
        shipToCompanyID: this.dataRFQ.shipToCompanyID || this.dataRFQ.customerCompanyID || null
      }
    },
    fieldPO () {
      return this.$store.state[this.moduleName].fieldPO
    },
    listRFQ1 () {
      return this.$store.state[this.moduleName].listRFQ1
    },
    listRFQ3 () {
      return this.$store.state[this.moduleName].listRFQ3
    },
    mapStep () {
      return this.steps.reduce((result, step) => {
        result[step.index] = step
        return result
      }, {})
    },
    apiAutoSave () {
      return `RFQs/Patch/${this.data.id}`
    },
    partIDs () {
      return this.listRFQ3
        .filter(({ _includeMultiple }) => !!_includeMultiple)
        .map(({ partID }) => partID)
    }
  },
  methods: {
    openCustomerRemainder () {
      const dialog = this.$refs['dialogCustomerRemainder']
      if (!dialog) return

      dialog.show()
    },
    handleCheckMultipleQuote (value, row) {
      this.$store.dispatch(`${this.moduleName}/checkMultipleRFQ3`, { value, data: row })
    },
    modelInfoPo () {
      return ModelInfoPOShort()
    },
    modelRFQ () {
      return ModelRFQs()
    },
    controller (command, step) {
      if (command === 'came-list-rfq-1') {
        if (!step.isValid) {
          this.currentStep = 2
        }
      }
      if (command === 'came-list-rfq-3') {
        if (!this.listRFQ3.length) {
          this.currentStep = 2
          this.mapStep[3].showButton = true
        } else {
          this.currentStep = 3
          this.mapStep[3].showButton = true
        }
      }
      if (command === 'show-po') {
        step.showButton = false
        this.currentStep = 4
      }
      if (command === 'hide-po') {
        this.currentStep = 3
        step.showButton = true
      }
    },
    handleCreatePO (data) {
      this.$bus.$emitPromise('validate-to-create-po')
        .then(() => {
          return this.$store.dispatch(`${this.moduleName}/createPO`, data)
            .then(() => {
              const query = {
                'customer-po-open': `edit[${this.data.id}]`
              }
              this.$router.replace({ name: 'CustomerPoOpen', query })
            })
            .catch((e) => {
              this.requestErrorHandler(e)
            })
        })
        .catch((e) => {
          this.validateErrorHandler(e)
        })
    },
    handleChangeData () {
      this.$store.commit(`${this.moduleName}/SET`, { key: 'dataRFQ', value: this.data })
      this.$store.commit(`${this.moduleName}/SET`, { key: 'fieldPO', value: this.data.po })
      this.$nextTick(() => {
        this.$bus.$emit(`on-came-data-editor-${this.eventID}`, this.data)
      })
    },
    handleReset () {
      this.$store.dispatch(`${this.moduleName}/resetState`)
    },
    handleChangeReset () {
      this.$store.dispatch(`${this.moduleName}/resetState`)
    },
    openDialogAddToRFQ3 (dataRFQ1) {
      let dialog = this.$refs['dialog-add-to-rfq3']
      dialog.open(dataRFQ1, (data) => {
        this.isLoading = true
        this.handlerAddRFQ1ToRFQ3(data)
          .then(() => {
            this.isLoading = false
            dialog.close()
            this.requestSuccessHandler()
          })
          .catch((err) => {
            this.isLoading = false
            this.requestErrorHandler(err)
          })
      })
    },
    sendQuoteToCustomerEmail (data, noStock) {
      this.dataRFQ3Send = { ...data }
      this.$nextTick(() => {
        this.$refs.dialogSendQuote.show({ noStock })
      })
    },
    sendQuoteFollowUp (data) {
      this.dataRFQ3Send = { ...data }
      this.$nextTick(() => {
        this.$refs.dialogSendQuote.show({ isFollowUp: true })
      })
    },
    sendQuoteToCustomerEmailPart (dataRFQ1) {
      const { id } = dataRFQ1
      this.$nextTick(() => {
        this.$refs.dialogSendQuotePart.show({ id })
      })
    },
    sendQuoteMultiParts (logoType) {
      this.$refs.dialogSendQuoteMultiParts.show({ logoType })
    },
    handlerSuccessCustomerEmail () {
      this.$bus.$emit(`refresh-data-${this.eventID}`)
    },
    /**
     * @desc Add new RFQ1 to RFQ3
     * @param data { Object } - Data for RFQ3
     * @async
     * @return {Promise}
     */
    handlerAddRFQ1ToRFQ3 (data) {
      return this.$store.dispatch(`${this.moduleName}/addRFQ1ToRFQ3`, data)
        .then(() => {
          this.$bus.$emit(`refresh-data-${this.eventID}`)
        })
    },
    // FROM MIXIN FROM WRAPPER
    requestGetData () {
      if (this.currentID) {
        this.isLoading = true
        return ServiceRFQs.getByRFQID(this.currentID)
          .then(({ data }) => {
            this.handleRequestGetData(data)
          })
      }
    },
    handleUpdatePO (value) {
      this.$store.commit(`${this.moduleName}/SET`, { key: 'fieldPO', value })
    },
    // FROM MIXIN AUTO SAVE
    mixSuccessAutoSave (data) {
      this.$store.commit(`${this.moduleName}/UPDATE`, { key: 'dataRFQ', value: data })
    },
    mixErrorAutoSave () {
      this.$store.commit(`${this.moduleName}/UPDATE`, { key: 'dataRFQ', value: {} })
    }
  }
}
</script>
